import { FC } from 'react';
import { FilterOptions } from '@zoopla/redux-types';

type BedsOptions = {
    options: FilterOptions;
    bedsOtherInt: number;
    keyPrefix: string;
};

export const SelectBedsMinOptions: FC<React.PropsWithChildren<BedsOptions>> = ({
    options,
    bedsOtherInt,
    keyPrefix
}) => {
    const bedsMaxInt = bedsOtherInt;

    return (
        // see: https://github.com/yannickcr/eslint-plugin-react/issues/2584
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {options
                ?.filter(
                    (bedMinOption) =>
                        isNaN(bedsMaxInt) ||
                        bedMinOption.value === '' ||
                        bedsMaxInt >= parseInt(bedMinOption.value)
                )
                ?.map((bedMinOption) => {
                    if (!bedMinOption) {
                        return null;
                    }
                    const { value, label } = bedMinOption;
                    const key = `${keyPrefix}-${value}`;

                    return (
                        <option key={key} value={value}>
                            {label}
                        </option>
                    );
                }) ?? []}
        </>
    );
};

export const SelectBedsMaxOptions: FC<React.PropsWithChildren<BedsOptions>> = ({
    options,
    bedsOtherInt,
    keyPrefix
}) => {
    const bedsMinInt = bedsOtherInt;

    return (
        // see: https://github.com/yannickcr/eslint-plugin-react/issues/2584
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {options
                ?.filter(
                    (bedMaxOption) =>
                        isNaN(bedsMinInt) ||
                        bedMaxOption.value === '' ||
                        bedsMinInt <= parseInt(bedMaxOption.value)
                )
                ?.map((bedMaxOption) => {
                    if (!bedMaxOption) {
                        return null;
                    }
                    const { value, label } = bedMaxOption;
                    const key = `${keyPrefix}-${value}`;

                    return (
                        <option key={key} value={value}>
                            {label}
                        </option>
                    );
                }) ?? []}
        </>
    );
};
